import { formulaLabel } from '../config/formulaTypes';

// For a deal sitting below a hypothetical threshold, identify
// which question(s) contributed the least relative to their
// maximum possible weighted score — i.e. the biggest gap
// between what was scored and what was possible.

export function identifyDragFactors(scoredResponses, rubricQuestions) {
  return scoredResponses
    .map(response => {
      const question = rubricQuestions.find(
        q => q.question_id === response.question_id
      );
      if (!question) return null;

      const maxPossibleScore = getMaxScoreForQuestion(question);
      const maxPossibleWeighted = maxPossibleScore * question.weight;
      const actualWeighted = response.weighted_score;
      const gap = maxPossibleWeighted - actualWeighted;

      // Include the formula in the label for derived questions, by its display
      // name rather than the raw code — two questions can share wording and be
      // different metrics (the reporting-currency and USD CAGRs especially).
      const questionText = question.is_derived && question.formula_type
        ? `${question.question_text} (${formulaLabel(question.formula_type)})`
        : question.question_text;

      return {
        question_id: response.question_id,
        question_text: questionText,
        actual_weighted: actualWeighted,
        max_possible_weighted: maxPossibleWeighted,
        gap,
        gap_percentage: maxPossibleWeighted > 0
          ? (gap / maxPossibleWeighted) * 100
          : 0,
      };
    })
    .filter(Boolean)
    .sort((a, b) => b.gap - a.gap)
    .slice(0, 3); // top 3 drag factors
}

function getMaxScoreForQuestion(question) {
  if (question.response_type === 'binary' ||
      question.response_type === 'multiple_choice') {
    if (!question.options?.length) return 0;
    return Math.max(...question.options.map(o => o.score));
  }
  if (question.response_type === 'figure') {
    if (!question.figure_score_bands?.length) return 0;
    return Math.max(...question.figure_score_bands.map(b => b.score));
  }
  if (question.response_type === 'derived') {
    // Derived questions use figure_score_bands — max score is the highest band score
    if (!question.figure_score_bands?.length) return 0;
    return Math.max(...question.figure_score_bands.map(b => b.score));
  }
  return 0;
}
